var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56793_63607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.531 16.617L22.814 20.899L21.399 22.314L17.117 18.031C15.5237 19.3082 13.542 20.0029 11.5 20C6.532 20 2.5 15.968 2.5 11C2.5 6.032 6.532 2 11.5 2C16.468 2 20.5 6.032 20.5 11C20.5029 13.042 19.8082 15.0237 18.531 16.617ZM16.525 15.875C17.7941 14.5699 18.5029 12.8204 18.5 11C18.5 7.132 15.367 4 11.5 4C7.632 4 4.5 7.132 4.5 11C4.5 14.867 7.632 18 11.5 18C13.3204 18.0029 15.0699 17.2941 16.375 16.025L16.525 15.875Z",
    fill: "#A0A7A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56793_63607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6cc0acd7f8a57c29f011317668438fff.svg";
export { ForwardRef as ReactComponent };